import React from "react";

import { ProcessPathState } from "src/pages/settings/tabs/siteLayout/types";
import ProcessPathCard from "./ProcessPathCard";

export interface ProcessPathCardListProps {
  processPaths: ProcessPathState[];
}

const ProcessPathCardList: React.FC<ProcessPathCardListProps> = ({
  processPaths,
}) => {
  return (
    <div data-testid="process-path-card-list">
      {processPaths.map((processPath, index) => (
        <ProcessPathCard
          key={`${processPath.processId}-${processPath.functionId}`}
          processPath={processPath}
          processPathIndex={index}
        />
      ))}
    </div>
  );
};

export default ProcessPathCardList;
